import type { CodeConfirmData } from 'app/widgets/CodeConfirmation';
import { CodeError } from 'app/widgets/CodeConfirmation';

export enum Step {
  INITIAL,
  CODE,
  PASSWORD,
  DONE,
}

export enum DataName {
  PHONE = 'phone',
  EMAIL = 'email',
}

export type RestorePassword = {
  show: boolean;
  phone: string;
};

type InitialFormValuesName = 'phoneNumber' | 'email';

export type HeaderTitle = Record<string, string>;

export type InitialFormValues = {
  phoneNumber: string;
  email: string;
  name: InitialFormValuesName;
};

export type PasswordFormValues = {
  newPass: string;
  confirmPass: string;
  login: string;
};

export type DataType = Record<InitialFormValuesName, string>;

export type RequestBody = {
  type?: string;
  requisite? : string;
  phoneNumber?: string;
  email?: string;
  code?: string;
  token?: string;
  password?: string;
};

export type UserData = CodeConfirmData & {
  type: string;
  token: string;
  disabled: boolean;
  checked: boolean;
  codeError: CodeError | null;
};
